import {fragments} from '@/gql';
import gql from 'graphql-tag';
export default gql`
  query CallsheetAnalysisProgress($id: ID!) {
    CallsheetAnalysisProgress(id: $id) {
      ...callsheetAnalysisProgressDetail
    }
  }
  ${fragments.callsheetAnalysisProgressDetail}
`;
